const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('@/components/pages/SignIn.vue'),
    children: [
      {
        path: '/signin/callback',
        name: 'signin-callback',
      },
    ],
  },
  {
    path: '/signup-en',
    name: 'signup-en',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup',
    name: 'signup',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
    children: [
      {
        path: '/signup/callback',
        name: 'signup-callback',
      },
      {
        path: '/signup/cpa/callback',
        name: 'signup-cpa-callback',
      },
    ],
  },
  {
    path: '/personal-infos',
    name: 'personal-infos',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/PersonalInfos.vue'),
  },
  {
    path: '/company-infos',
    name: 'company-infos',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/CompanyInfos.vue'),
  },
  {
    path: '/partner/integration',
    name: 'partner-integration',
    meta: {layout: 'no-auth'},
    component: () =>
      import(
        '@/components/pages/PartnerIntegration/IntegratingPartnerDynamic.vue'
      ),
  },
  {
    path: '/partner/manual-flow',
    name: 'partner-manual-flow',
    meta: {layout: 'no-auth'},
    component: () =>
      import('@/components/pages/PartnerIntegration/PartnerManualFlow.vue'),
  },
  {
    path: '/signup-cpa',
    name: 'signup-cpa',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/libeo',
    name: 'signup-libeo',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/axonaut',
    name: 'signup-axonaut',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/odoo',
    name: 'signup-odoo',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/evoliz',
    name: 'signup-evoliz',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/pennylane',
    name: 'signup-pennylane',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/progbat',
    name: 'signup-progbat',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup/partner/:partner_name',
    name: 'signup-partner',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/signup-cpa-rca',
    name: 'signup-cpa-rca',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/passwordrecovery',
    name: 'recovery',
    component: () => import('@/components/pages/PasswordRecovery.vue'),
  },
  {
    path: '/completeSignUp',
    name: 'completeSignUp',
    component: () => import('@/components/pages/SignUp.vue'),
  },
  {
    path: '/console',
    name: 'console',
    component: () => import('@/components/pages/Console.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/components/pages/Dashboard.vue'),
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('@/components/pages/Invoices.vue'),
  },
  {
    path: '/checks',
    name: 'checks',
    component: () => import('@/components/pages/Checks.vue'),
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: () => import('@/components/pages/Transactions.vue'),
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/components/pages/Categories.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/components/pages/Profile.vue'),
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('@/components/pages/Company.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/components/pages/AdminWrapper.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/components/pages/CompanyUsers.vue'),
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/components/pages/BankConfirmation.vue'),
  },
  {
    path: '/acceptInvite',
    name: 'acceptInvite',
    component: () => import('@/components/pages/AcceptInvite.vue'),
  },
  {
    path: '/cabinet',
    name: 'cabinet',
    component: () => import('@/components/pages/Company.vue'),
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    redirect: {name: 'onboarding-welcome'},
    meta: {layout: 'no-auth'},
    component: () =>
      import('@/components/pages/NoBanksOnboarding/NoBanksOnboarding.vue'),
    children: [
      {
        path: 'welcome',
        meta: {layout: 'no-auth'},
        name: 'onboarding-welcome',
        component: () =>
          import('@/components/pages/NoBanksOnboarding/OnboardingWelcome.vue'),
      },
      {
        path: 'why-connect',
        meta: {layout: 'no-auth'},
        name: 'onboarding-why-connect',
        component: () =>
          import(
            '@/components/pages/NoBanksOnboarding/PourquoiConnecterBank.vue'
          ),
      },
      {
        path: 'add-bank',
        meta: {layout: 'no-auth'},
        name: 'onboarding-add-bank',
        component: () =>
          import('@/components/pages/NoBanksOnboarding/OnboardingAddBank.vue'),
      },
      {
        path: 'book-a-demo',
        meta: {layout: 'no-auth'},
        name: 'onboarding-book-a-demo',
        component: () =>
          import(
            '@/components/pages/NoBanksOnboarding/OnboardingBookADemo.vue'
          ),
      },
    ],
  },
  {
    path: '/treasury-investment',
    name: 'treasury-investment',
    redirect: {name: 'treasury-investment-intro'},
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/TreasuryInvestment.vue'),
    children: [
      {
        path: 'intro',
        name: 'treasury-investment-intro',
        meta: {step: 0},
        component: () =>
          import('@/components/pages/TreasuryInvestment/Intro.vue'),
      },
      {
        path: 'profile',
        name: 'treasury-investment-profile',
        meta: {step: 1},
        component: () =>
          import('@/components/pages/TreasuryInvestment/Profile.vue'),
      },
      {
        path: 'rules',
        name: 'treasury-investment-rules',
        meta: {step: 2},
        component: () =>
          import('@/components/pages/TreasuryInvestment/Rules.vue'),
      },
      {
        path: 'personal-info',
        name: 'treasury-investment-personal-info',
        meta: {step: 3},
        component: () =>
          import('@/components/pages/TreasuryInvestment/PersonalInfo.vue'),
      },
      {
        path: 'company-info',
        name: 'treasury-investment-company-info',
        meta: {step: 3},
        component: () =>
          import('@/components/pages/TreasuryInvestment/CompanyInfo.vue'),
      },
      {
        path: 'documents',
        name: 'treasury-investment-documents',
        meta: {step: 4},
        component: () =>
          import('@/components/pages/TreasuryInvestment/Documents.vue'),
      },
      {
        path: 'final/:type?',
        name: 'treasury-investment-final',
        meta: {step: 5},
        component: () =>
          import('@/components/pages/TreasuryInvestment/Final.vue'),
      },
    ],
  },
  {
    path: '/my-investments',
    name: 'my-investments',
    redirect: {name: 'my-investments-home'},
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/MyInvestments.vue'),
    children: [
      {
        path: 'home',
        name: 'my-investments-home',
        component: () =>
          import('@/components/pages/MyInvestments/MyInvestmentsTable.vue'),
      },
      {
        path: 'invest/:currency?/:flow?/:idPayment?',
        name: 'my-investments-invest',
        component: () => import('@/components/pages/MyInvestments/Invest.vue'),
      },
      {
        path: 'withdraw/:currency?',
        name: 'my-investments-withdraw',
        component: () =>
          import('@/components/pages/MyInvestments/Withdraw.vue'),
      },
    ],
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('@/components/pages/Analytics.vue'),
  },
  {
    path: '/partner/selection',
    name: 'partner-selection',
    meta: {layout: 'no-auth'},
    component: () =>
      import(
        '@/components/pages/PartnerIntegration/ChoosePartnerIntegration.vue'
      ),
  },
  {
    path: '/partner/callback',
    name: 'partner-callback',
    meta: {layout: 'no-auth'},
    component: () =>
      import(
        '@/components/pages/PartnerIntegration/ChoosePartnerIntegration.vue'
      ),
  },
  {
    path: '/no-permissions',
    name: 'no-permissions',
    component: () => import('@/components/pages/NoPermissions.vue'),
  },
  {
    path: '/book-a-meeting',
    name: 'book-a-meeting',
    component: () => import('@/components/pages/BookMeeting.vue'),
  },
  {
    path: '/book-a-meeting-analytics',
    name: 'book-a-meeting-analytics',
    component: () =>
      import('@/components/elements/Analytics/Reports/HelpMeeting.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard',
  },
  {
    path: '/transfer/callback',
    name: 'transfer-callback',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/TransferSummary.vue'),
  },
  {
    path: '/bank-transfers',
    name: 'bank-transfers',
    meta: {layout: 'no-auth'},
    component: () =>
      import('@/components/pages/BankTransfers/BankTransfers.vue'),
  },
  {
    path: '/bank-transfers/callback',
    name: 'bank-transfers-callback',
    meta: {layout: 'no-auth'},
    component: () =>
      import('@/components/pages/BankTransfers/BankTransfersCallback.vue'),
  },
  {
    path: '/bank-transfers/company-info',
    name: 'bank-transfers-company',
    meta: {layout: 'no-auth'},
    component: () =>
      import('@/components/pages/BankTransfers/BankTransfersCompanyInfo.vue'),
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/MaintenanceView.vue'),
  },
];

export default routes;
